// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__2KLHO","clinicsSelect":"TableHeading_clinicsSelect__1wEbX"};